import React, { useEffect } from 'react';

const withGoogleOptimize = <T extends object>(
  WrappedComponent: React.ComponentType<T>
) => {
  const HOC = (props: T) => {
    useEffect(() => {
      if (window.IH && window.IH.googleOptimizeEnabled) {
        window.dataLayer.push({ event: 'optimize.activate' });
      }
    }, []);

    return <WrappedComponent {...props} />;
  };

  return HOC;
};

export default withGoogleOptimize;
